import 'intersection-observer'
import './lib/picturefill'
import './lib/ie-fixes'
import './lib/polyfills'
import loadImgLazyloadScript from './modules/lazyload-images'
import siteNavigationHandler from './modules/site-navigation'
import searchHandler from './modules/search-handler'
import handleCookieDialog from './modules/cookie-dialog'
import sliderHandler from './modules/sliders'
import newsletterSignup from './modules/newsletter-signup'
import embedVideoPlayer from './modules/embed-video-player'
import articleVideoHandler from './modules/article-video-handler'
import loadPlaceholderImages from './modules/image-placeholders'
import sneakpeakFormHandler from './modules/sneakpeek-handler'
import categoryDescriptionHandler from './modules/category-desc'
import eventTracking from './modules/event-tracking'
import youtubeHandler from './modules/youtubeHandler'
import SubmissionForm from './modules/SubmissionForm'

window.consentUpdatedEventSent = false;

function sendConsentUpdateEvent() {
    window.consentUpdatedEventSent = true;

    setTimeout(() => {
        // Initialize the dataLayer if it doesn't exist and push the update event.
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "consent_updated"
        });
    }, 300);
}

// Listen for a custom "wcc_consent_update" event and trigger the consent update.
document.addEventListener("wcc_consent_update", function (eventData) {
    sendConsentUpdateEvent();
});

// Additionally, trigger the consent update when the window finishes loading.
window.addEventListener("load", function() {
    if (window.consentUpdatedEventSent) {
        // Don't send the event on window load if it has already been sent
        return;
    }

    sendConsentUpdateEvent();
});

function loadJS() {
  (document.querySelectorAll('a')).forEach(link => {
    link.hostname !== location.hostname && link.setAttribute('target', '_blank');
  })

  document.createElement('picture')
  youtubeHandler()
  eventTracking()
  loadPlaceholderImages()
  siteNavigationHandler()
  searchHandler()
  handleCookieDialog()
  sliderHandler()
  newsletterSignup()
  embedVideoPlayer()
  articleVideoHandler()
  sneakpeakFormHandler()
  categoryDescriptionHandler()
  SubmissionForm()
}
loadImgLazyloadScript(window, document)

document.addEventListener('DOMContentLoaded', loadJS())
